define('flight-components/GeoSearch',[
  'App',
  'flight/lib/component',
  'flight-components/mixins/withGeoValidation',
  'flight-components/mixins/withGeoSuggest',
  'URIjs/URI'
],

function(App, defineComponent, withGeoValidation, withGeoSuggest, URI){

  var GeoSearch = function GeoSearch() {


    this.defaultAttrs({
      typeahead: true,
      formSelector: '[data-form="geo-search"]',
      geoInputSelector: 'input[name="geo"]',
      f1InputSelector: 'input[name="f1"]',
      keywordsInputSelector: 'input[name="keywords"]',
      catNameInputSelector: 'input[name="catName"]',
      contentSelector: '.geo-change__content',
      errorMsgSelector: '.input-error-msg',
      redirect: true
    });


    this.submitGeoChange = function(ev, data) {
      var self = this;

      var geo = data.geo;
      var f1 = self.select('f1InputSelector').val();
      var keywords = self.select('keywordsInputSelector').val();
      var catName = self.select('catNameInputSelector').val();
      var currentUrl = URI(window.location.href);

      if (self.attr.redirect) {
        self.trigger('uiCouponQueryRequested', {
          geo: geo,
          f1: f1,
          keywords: keywords,
          catName: catName
        });
      } else {
        window.location.href = currentUrl.addSearch('geo', geo).toString();
      }
    }


    this.after('initialize', function() {

      var self = this;

      this.select('formSelector').on('submit', function(ev){
        ev.preventDefault();
        self.validateGeo();
      });

      this.on('dataGeoValidated', this.submitGeoChange);
      this.select('contentSelector').removeClass('js-invisible');


    });

  };

  return defineComponent(GeoSearch, withGeoValidation, withGeoSuggest);
});

